import React, { Fragment, useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid2 from "@mui/material/Grid2";
import CircularProgress from "@mui/material/CircularProgress";
import { uploadDeviceFactoryFirmware, uploadDeviceFactoryFirmwareWithAutoSign, downloadDeviceFactoryFirmwareFile, getDeviceFactoryFirmwareData, getDeviceModelNumbersList } from "../../../action/firmware";
import { setAlert } from "../../../action/alert";
import CloudDownload from "@mui/icons-material/CloudDownload";
import customConfig from "../../../config";
import { selectMenuProps } from "../../../utils/selectMenuProps";
import FormInput from "../../Common/FormInputs/MuiTextField";
import AppCheckbox from "../../Common/FormInputs/AppCheckbox";
import AppRadioGroup from "../../Common/FormInputs/AppRadioGroup";
import AppButton from "../../Common/Button/Button";
import DataTable from "../../Common/DataTable/DataTable";
import AppTabs from "../../Common/Tabs/AppTabs";
import { LabelText } from "../../Common/Typography/AppTypography";
import { useTheme } from "@mui/material/styles";
import { useDesignTokens } from "../../../theme/useDesignTokens";

const formControlSx = (theme) => ({ width: "100%", maxWidth: "100%", [theme.breakpoints.up("md")]: { maxWidth: 280 } });
const TABLE_HEADERS = {
    firmwareVersion: "Firmware Version",
    deviceCount: "Device Count",
    firmwareImage: "Firmware Image",
    firmwareSign: "Firmware Signature",
};

const FACTORY_TABS = [{ label: "View Firmware Info" }, { label: "Upload Firmware" }];

const DeviceFactoryFirmware = ({
    allowedDeviceCategories,
    allowedCompanyBrand,
    firmwareData,
    uploadDeviceFactoryFirmware,
    uploadDeviceFactoryFirmwareWithAutoSign,
    downloadDeviceFactoryFirmwareFile,
    setAlert,
}) => {
    const [activeTab, setActiveTab] = useState(0);

    return (
        <Box sx={{ width: "100%", minWidth: 0 }} className="device-firmware-nested-tabs">
            <AppTabs
                value={activeTab}
                onChange={(e, newValue) => setActiveTab(newValue)}
                tabs={FACTORY_TABS}
                variant="scrollable"
                scrollButtons="auto"
                tabMinWidth="auto"
                appearance="neutral"
                sx={{ mt: 2 }}
            />
            {activeTab === 0 && (
                <ViewFirmwareInfo
                    allowedDeviceCategories={allowedDeviceCategories}
                    allowedCompanyBrand={allowedCompanyBrand}
                    downloadDeviceFactoryFirmwareFile={downloadDeviceFactoryFirmwareFile}
                    setAlert={setAlert}
                />
            )}
            {activeTab === 1 && (
                <UploadFirmware
                    allowedDeviceCategories={allowedDeviceCategories}
                    allowedCompanyBrand={allowedCompanyBrand}
                    firmwareData={firmwareData}
                    uploadDeviceFactoryFirmware={uploadDeviceFactoryFirmware}
                    uploadDeviceFactoryFirmwareWithAutoSign={uploadDeviceFactoryFirmwareWithAutoSign}
                    setAlert={setAlert}
                />
            )}
        </Box>
    );
};

const ViewFirmwareInfo = ({
    allowedDeviceCategories,
    allowedCompanyBrand,
    setAlert,
    downloadDeviceFactoryFirmwareFile,
}) => {
    const { colors } = useDesignTokens();
    const [categoryFilter, setCategoryFilter] = useState("");
    const [brandFilter, setBrandFilter] = useState("");
    const [chipTypeFilter, setChipTypeFilter] = useState("")
    const [deviceFirmwareData, setDeviceFirmwareData] = useState([]);
    const [isDeviceFirmwareDataLoading, setIsDeviceFirmwareDataLoading] = useState(false);
    const [showFirmwareDataList, setShowFirmwareDataList] = useState(false)
    const [updateFlag, setUpdateFlag] = useState(undefined);
    const [isFilterDisabled, setIsFilterDisabled] = useState(false);


    useEffect(() => {
        setShowFirmwareDataList(false)
    }, [categoryFilter, brandFilter, chipTypeFilter])

    useEffect(() => {
        if (!categoryFilter || categoryFilter.length===0) {
            return
        }
        if (!brandFilter || brandFilter.length===0) {
            return
        }
        if (!chipTypeFilter || chipTypeFilter.length===0) {
            return
        }
        getFirmwareData();

    }, [updateFlag]);

    function downloadFile(firmwareVersion, fileType) {
        let params = {
            'brand': brandFilter,
            'category': categoryFilter,
            'version': firmwareVersion,
            'chipType': chipTypeFilter
        }

        downloadDeviceFactoryFirmwareFile(params, fileType)
    };

    function filterDeviceFirmwareData() {
        if (!categoryFilter || categoryFilter.length===0) {
            setAlert("Category Cannot be Empty", 'danger')
            return
        }

        if (!brandFilter || brandFilter.length===0) {
            setAlert("Brand Cannot be Empty", 'danger')
            return
        }

        if (!chipTypeFilter || chipTypeFilter.length===0) {
            setAlert("Chip Type Cannot be Empty", 'danger')
            return
        }

        setIsFilterDisabled(true);
        setUpdateFlag(Math.random());
    };

    function resetFilters() {
        setCategoryFilter("")
        setBrandFilter("")
        setChipTypeFilter("")
        setUpdateFlag(Math.random())
        setIsFilterDisabled(false)
    };

    const getFirmwareData = () => {

        setIsDeviceFirmwareDataLoading(true);

        let filterParams = {}
        if (categoryFilter && categoryFilter.length!==0) {
            filterParams['category'] = categoryFilter
        }

        if (brandFilter && brandFilter.length!==0) {
            filterParams['brand'] = brandFilter
        }

        if (chipTypeFilter && chipTypeFilter.length!==0) {
            filterParams['chipType'] = chipTypeFilter
        }

        getDeviceFactoryFirmwareData(filterParams)
            .then((res) => {
                setIsDeviceFirmwareDataLoading(false);
                setShowFirmwareDataList(true)
                setDeviceFirmwareData(res)
                setIsFilterDisabled(false);
            })
            .catch((err) => {
                setIsDeviceFirmwareDataLoading(false);
                setIsFilterDisabled(false);
                setAlert(err?.response?.data?.message ?? "Failed to Get Factory Firmware Details", "danger")
            });
    };

    // if (isDeviceFirmwareDataLoading) {
    //     return <div style={{ display: "grid", placeItems: "center", height: "20vh" }}>
    //         <CircularProgress size="5em" style={{ color: "#AFB42B" }} />
    //     </div>
    // }
    
    const buildDownloadLink = (firmwareVersion, fileType) => (
        <Box
            component="span"
            sx={{ cursor: "pointer", textDecoration: "underline", display: "inline-flex", alignItems: "center" }}
            onClick={() => downloadFile(firmwareVersion, fileType)}
        >
            <CloudDownload sx={{ color: "black", fontSize: 20 }} />
        </Box>
    );

    const chipTypeOptions =
        categoryFilter === customConfig.deviceCategoryODMFRONTLOADWM
            ? (customConfig.chipTypesByCategory.factoryFLWM || [])
            : categoryFilter === customConfig.deviceCategoryLED
                ? (customConfig.chipTypesByCategory.LED || [])
                : (customConfig.matterChipType || []);

    const tableColumns = [
        { key: "firmwareVersion", label: TABLE_HEADERS.firmwareVersion, minWidth: 140 },
        { key: "deviceCount", label: TABLE_HEADERS.deviceCount, minWidth: 120 },
        { key: "firmwareImage", label: TABLE_HEADERS.firmwareImage, minWidth: 120, render: (_, row) => buildDownloadLink(row.firmwareVersion, "firmwareImage") },
        { key: "firmwareSign", label: TABLE_HEADERS.firmwareSign, minWidth: 120, render: (_, row) => buildDownloadLink(row.firmwareVersion, "firmwareSign") },
    ];

    return (
        <Fragment>
            <Paper sx={{ p: 2, boxShadow: 2, borderRadius: 1, mb: 2 }}>
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", lg: "1fr 1fr 1fr auto" },
                        gap: 2.5,
                        alignItems: "center",
                        maxWidth: "100%",
                    }}
                >
                    <FormInput
                        type="select"
                        label="Category"
                        size="small"
                        fullWidth
                        name="categoryFilter"
                        value={categoryFilter}
                        onChange={(e) => setCategoryFilter(e.target.value)}
                        options={(allowedDeviceCategories || []).map((el) => ({ value: el, label: el }))}
                        MenuProps={selectMenuProps}
                        sx={{ minWidth: 0 }}
                    />
                    <FormInput
                        type="select"
                        label="Brand"
                        size="small"
                        fullWidth
                        name="brandFilter"
                        value={brandFilter}
                        onChange={(e) => setBrandFilter(e.target.value)}
                        options={(allowedCompanyBrand || []).map((el) => ({ value: el, label: el }))}
                        MenuProps={selectMenuProps}
                        sx={{ minWidth: 0 }}
                    />
                    <FormInput
                        type="select"
                        label="Chip Type"
                        size="small"
                        fullWidth
                        name="chipTypeFilter"
                        value={chipTypeFilter}
                        onChange={(e) => setChipTypeFilter(e.target.value)}
                        options={chipTypeOptions.map((el) => ({ value: el, label: el }))}
                        MenuProps={selectMenuProps}
                        sx={{ minWidth: 0 }}
                    />
                    <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap", justifyContent: { xs: "flex-start", lg: "flex-end" } }}>
                        <AppButton variant="primary" size="medium" onClick={filterDeviceFirmwareData} disabled={isFilterDisabled}>
                            Filter
                        </AppButton>
                        <AppButton variant="ghost" size="medium" onClick={resetFilters}>
                            Reset
                        </AppButton>
                    </Box>
                </Box>
            </Paper>
            {isDeviceFirmwareDataLoading ? (
                <Box sx={{ display: "grid", placeItems: "center", height: "20vh" }}>
                    <CircularProgress size={48} sx={{ color: colors?.primary?.main || "#AFB42B" }} />
                </Box>
            ) : (
                showFirmwareDataList && (
                    <Paper sx={{ p: 2, mb: 2, boxShadow: 2, borderRadius: 1 }}>
                        <DataTable
                            columns={tableColumns}
                            data={deviceFirmwareData}
                            rowKey="firmwareVersion"
                            minWidth="100%"
                            maxHeight={{ xs: "none", md: "58vh" }}
                            stickyHeader
                            striped={false}
                            hoverEffect={true}
                            tableContainerSx={{ boxShadow: "none", borderRadius: 0 }}
                            msgForDisplay="No Data found"
                        />
                    </Paper>
                )
            )}
        </Fragment>
    );
}

const UploadFirmware = ({
    allowedDeviceCategories,
    allowedCompanyBrand,
    firmwareData: { uploadDeviceFactoryFirmwareInProgress },
    uploadDeviceFactoryFirmware,
    uploadDeviceFactoryFirmwareWithAutoSign,
    setAlert,
}) => {
    const theme = useTheme();
    const defaultChipType = "ESPWIFI";

    const [uploadedCategoryName, setUploadedCategoryName] = useState("")
    const [uploadedBrandName, setUploadedBrandName] = useState("")
    const [uploadedFirmwareVersion, setUploadedFirmwareVersion] = useState("")
    const [uploadedFirmwareImage, setUploadedFirmwareImage] = useState("")
    const [uploadedFirmwareSign, setUploadedFirmwareSign] = useState("")
    const [chipType, setChipType] = useState(defaultChipType)
    const [uploadMode, setUploadMode] = useState("with-signature")
    const [isMandatoryVersion, setIsMandatoryVersion] = useState(false)
    

    const firmwareImageInput = useRef()
    const firmwareSignInput = useRef()


    function handleUploadDeviceFirmware() {
        if (!uploadedCategoryName || uploadedCategoryName.length===0) {
            setAlert('Category Name Cannot be Empty', 'danger')
            window.scrollTo(0, 0);
            return
        }
        if (!uploadedBrandName || uploadedBrandName.length===0) {
            setAlert('Brand Name Cannot be Empty', 'danger')
            window.scrollTo(0, 0);
            return
        }
        if (!uploadedFirmwareVersion || uploadedFirmwareVersion.length===0 || uploadedFirmwareVersion.match('^[0-9]{1,2}\\.[0-9]{1,2}$')===null) {
            setAlert('Invalid Firmware Version', 'danger')
            window.scrollTo(0, 0);
            return
        }
       if (!uploadedFirmwareImage || uploadedFirmwareImage==="") {
            setAlert('Firmware Image Cannot be Empty', 'danger')
            window.scrollTo(0, 0);
            return
        }
        if (!uploadedFirmwareImage.name.endsWith('.tar.gz')) {
            setAlert('Firmware Image should follow "*.tar.gz" name format.', 'danger')
            window.scrollTo(0, 0);
            return;
        }

    let formData = new FormData()
    formData.append('files', uploadedFirmwareImage)
    formData.append('brand', uploadedBrandName)
    formData.append('category', uploadedCategoryName)
    formData.append('firmwareVersion', uploadedFirmwareVersion)
    formData.append('chipType', chipType)
    formData.append('isMandatoryVersion', isMandatoryVersion)


    if (uploadMode === "with-signature") {
        if (!uploadedFirmwareSign || uploadedFirmwareSign==="" ) {
            setAlert('Invalid Signature File', 'danger')
            window.scrollTo(0, 0);
            return
        }
        if (!uploadedFirmwareSign.name.endsWith('.sign')) {
            setAlert('Firmware Signature should follow "*.sign" name format.', 'danger')
            window.scrollTo(0, 0);
            return;
        }
        formData.append('files', uploadedFirmwareSign)
        formData.append('signatureFileName', uploadedFirmwareSign.name)
        uploadDeviceFactoryFirmware(formData)
    } else {
        uploadDeviceFactoryFirmwareWithAutoSign(formData)
    }
}

    function handleDeviceUploadFirmwareReset() {
        setUploadedCategoryName("")
        setUploadedBrandName("")
        setUploadedFirmwareVersion("")
        setUploadedFirmwareImage("")
        setUploadedFirmwareSign("")
        setChipType(defaultChipType)
        setUploadMode("with-signature")

        firmwareImageInput.current.value = ""
        if (firmwareSignInput.current) {
            firmwareSignInput.current.value = ""
        }
    }

    const chipTypeOptions =
        uploadedCategoryName === customConfig.deviceCategoryODMFRONTLOADWM
            ? (customConfig.chipTypesByCategory.factoryFLWM || [])
            : uploadedCategoryName === customConfig.deviceCategoryLED
                ? (customConfig.chipTypesByCategory.LED || [])
                : (customConfig.matterChipType || []);

    return (
        <Fragment>
            <Paper sx={{ p: 2, boxShadow: 2, borderRadius: 1 }}>
                <Grid2 container spacing={2} sx={{ alignItems: "center" }}>
                    <Grid2 size={{ xs: 12, md: 2 }}><LabelText sx={{ fontWeight: 600 }}>Category:</LabelText></Grid2>
                    <Grid2 size={{ xs: 12, md: 10 }} sx={{ minWidth: 0 }}>
                        <FormInput type="select" size="small" fullWidth label="Category" value={uploadedCategoryName} onChange={(e) => setUploadedCategoryName(e.target.value)}
                            options={(allowedDeviceCategories || []).map((c) => ({ value: c, label: c }))}
                            MenuProps={selectMenuProps} sx={formControlSx(theme)} />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 2 }}><LabelText sx={{ fontWeight: 600 }}>Brand:</LabelText></Grid2>
                    <Grid2 size={{ xs: 12, md: 10 }} sx={{ minWidth: 0 }}>
                        <FormInput type="select" size="small" fullWidth label="Brand" value={uploadedBrandName} onChange={(e) => setUploadedBrandName(e.target.value)}
                            options={(allowedCompanyBrand || []).map((b) => ({ value: b, label: b }))}
                            MenuProps={selectMenuProps} sx={formControlSx(theme)} />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 2 }}><LabelText sx={{ fontWeight: 600 }}>Chip Type:</LabelText></Grid2>
                    <Grid2 size={{ xs: 12, md: 10 }} sx={{ minWidth: 0 }}>
                        <FormInput type="select" size="small" fullWidth label="Chip Type" value={chipType} onChange={(e) => setChipType(e.target.value)}
                            options={chipTypeOptions.map((t) => ({ value: t, label: t }))} MenuProps={selectMenuProps} sx={formControlSx(theme)} />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 2 }}><LabelText>Firmware Version:</LabelText></Grid2>
                    <Grid2 size={{ xs: 12, md: 10 }} sx={{ minWidth: 0 }}>
                        <FormInput type="text" size="small" fullWidth label="Firmware Version" value={uploadedFirmwareVersion} onChange={(e) => setUploadedFirmwareVersion(e.target.value)} sx={formControlSx(theme)} />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 2 }}><LabelText>Upload Mode:</LabelText></Grid2>
                    <Grid2 size={{ xs: 12, md: 10 }}>
                        <AppRadioGroup
                            value={uploadMode}
                            onChange={(e) => setUploadMode(e.target.value)}
                            row={false}
                            formControlSx={{ ml: "-11px" }}
                            optionLabelSx={{ whiteSpace: "nowrap" }}
                            options={[
                                { value: "with-signature", label: "Upload firmware image & signature" },
                                { value: "auto-sign", label: "Upload firmware image" },
                            ]}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 2 }} />
                    <Grid2 size={{ xs: 12, md: 10 }}>
                        <AppCheckbox
                            checked={!!isMandatoryVersion}
                            onChange={(e) => setIsMandatoryVersion(e.target.checked)}
                            label="Mark as Mandatory Version"
                            color="default"
                            size="small"
                            sx={{ ml: "-11px" }}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 2 }}><LabelText sx={{ fontWeight: 600 }}>Firmware Image:</LabelText></Grid2>
                    <Grid2 size={{ xs: 12, md: 10 }} sx={{ minWidth: 0 }}>
                        <Box sx={formControlSx(theme)}>
                            <input type="file" accept=".tar.gz" ref={firmwareImageInput} onChange={(e) => setUploadedFirmwareImage(e.target.files?.[0] || "")}
                                style={{ width: "100%", boxSizing: "border-box", padding: 8, border: "1px solid rgba(0,0,0,0.42)", borderRadius: 4 }} />
                        </Box>
                    </Grid2>
                    {uploadMode === "with-signature" && (
                        <>
                            <Grid2 size={{ xs: 12, md: 2 }}><LabelText sx={{ fontWeight: 600 }}>Firmware Signature:</LabelText></Grid2>
                            <Grid2 size={{ xs: 12, md: 10 }} sx={{ minWidth: 0 }}>
                                <Box sx={formControlSx(theme)}>
                                    <input type="file" accept=".sign" ref={firmwareSignInput} onChange={(e) => setUploadedFirmwareSign(e.target.files?.[0] || "")}
                                        style={{ width: "100%", boxSizing: "border-box", padding: 8, border: "1px solid rgba(0,0,0,0.42)", borderRadius: 4 }} />
                                </Box>
                            </Grid2>
                        </>
                    )}
                    <Grid2 size={12}>
                        <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap", mt: 1 }}>
                            <AppButton variant="primary" size="medium" onClick={handleUploadDeviceFirmware} disabled={!!uploadDeviceFactoryFirmwareInProgress} loading={!!uploadDeviceFactoryFirmwareInProgress}>Upload</AppButton>
                            <AppButton variant="ghost" size="medium" onClick={handleDeviceUploadFirmwareReset}>Reset</AppButton>
                        </Box>
                    </Grid2>
                </Grid2>
            </Paper>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({
    allowedDeviceCategories: state.auth.allowedDeviceCategories,
    allowedCompanyBrand: state.auth.allowCompanyBrand,
    firmwareData: state.firmware
});

const mapDispatchToProps = (dispatch) => ({
    setAlert: (message, status) => dispatch(setAlert(message, status)),
    uploadDeviceFactoryFirmware: (formData) => dispatch(uploadDeviceFactoryFirmware(formData)),
    uploadDeviceFactoryFirmwareWithAutoSign: (formData) => dispatch(uploadDeviceFactoryFirmwareWithAutoSign(formData)),
    downloadDeviceFactoryFirmwareFile: (params, fileType) => dispatch(downloadDeviceFactoryFirmwareFile(params, fileType))
});

export default connect(mapStateToProps, mapDispatchToProps)(DeviceFactoryFirmware);